import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core'
import { Subject } from 'rxjs'
import { TableData } from '../../../models/table-data'

@Component({
  selector: 'jml-lib-entity-subtypes',
  templateUrl: './entity-subtypes.component.html',
  styleUrls: ['./entity-subtypes.component.scss']
})
export class EntitySubtypesComponent implements OnInit, OnChanges {
  tableData: TableData

  @Input() subtype: string
  @Input() mainId: number
  @Input() mainType: string
  @Input() mainRepr: string

  @Input() refreshTrigger: Subject<[string, number]>

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.subtype) {
      this.tableData = new TableData(changes.subtype.currentValue).hideHeader()
    }
  }

  onEntityOperation() {
    if (this.refreshTrigger) {
      this.refreshTrigger.next([this.mainType, this.mainId])
    }
  }
}
